import React from 'react';

import { getDeviceColor } from '../constants';

import { TrapStatus } from 'api/InteractiveMap/types';

interface Props {
  caughtPests: number;
  status: TrapStatus;
  number: string | number;
  activityLabel?: string;
}

const MctSvg: React.FC<Props> = ({ caughtPests, status, number, activityLabel }) => {
  const color = getDeviceColor(status);
  const counterFontSize = 12;
  const textColor = status === TrapStatus.warning ? 'black' : 'white';
  return (
    <svg width="50" height="61" viewBox="0 0 50 61" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" x="15" y="20.5" rx="0" ry="0" fill={color} stroke="black" strokeWidth="1" />
      <text
        x="25"
        y="32"
        textAnchor="middle"
        dominantBaseline="middle"
        fill={textColor}
        fontWeight="bold"
        fontSize={counterFontSize}
        style={{ fontFamily: 'sans-serif' }}
      >
        {activityLabel ? activityLabel : caughtPests || '0'}
      </text>

      <text
        x="25"
        y="15"
        textAnchor="middle"
        fill="black"
        fontSize="18"
        fontWeight="bold"
        style={{ fontFamily: 'sans-serif' }}
      >
        {number}
      </text>
    </svg>
  );
};

export default MctSvg;
